import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthProvider";

const Profile = () => {
  const {user} = useAuth()
  const [data,setData] = useState(user)

  return (
    <div className=" ">
      <div className="p-2 md:p-5 bg-gray-200">

          <h1 className=" font-bold text-lg flex justify-center">Profile</h1>

      </div>
     <div className=" p-5">
     <div className="border border-gray-300 py-5 px-5 ">
        <h2 className="text-xl font-bold border-b pb-3">Profile Update</h2>

        <div className="flex flex-col md:flex-row flex-wrap justify-between gap-5 mt-5 text-sm font-medium">
          <div className="w-full md:w-[350px]">
            <label className="block mb-1">Choose Profile Picture</label>
            <input
              className="px-3 py-3 outline-none border border-gray-300 w-full"
              type="file"
            />
          </div>
          <div className="w-full md:w-[350px]">
            <label className="block mb-1">
              Full Name <span className="text-primary">*</span>
            </label>
            <input
              className="px-3 py-3 outline-none border border-gray-300 w-full"
              type="text"
              placeholder="First Name"
              value={data?.name}
            />
          </div>

          
          <div className="w-full md:w-[350px]">
            <label className="block mb-1">
              Email Address <span className="text-primary">*</span>
            </label>
            <input
              className="px-3 py-3 outline-none border border-gray-300 w-full"
              type="email"
              placeholder="Email"
              value={data?.email}
            />
          </div>

          <div className="w-full md:w-[350px]">
            <label className="block mb-1">
              Mobile Number <span className="text-primary">*</span>
            </label>
            <input
              className="px-3 py-3 outline-none border border-gray-300 w-full"
              type="tel"
              placeholder="Mobile"
              value={data?.phone}

            />
          </div>
        </div>

        <div className="mt-5">
          <button className="px-5 py-3 bg-primary text-white font-bold ">
            Save Changes
          </button>
        </div>
      </div>

      <div className="border border-gray-300 py-5 px-5 w-full mt-5 ">
        <h3 className="text-xl font-bold border-b pb-3">
          Change Your Password
        </h3>

        <div className="mt-5 text-sm font-medium">
          <label className="block mb-1">Old Password</label>
          <input
            className="w-full px-3 py-3 outline-none border border-gray-300"
            type="password"
            placeholder="Enter old password"
          />
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-5 mt-5 text-sm font-medium">
          <div className="w-full md:w-[350px]">
            <label className="block mb-1">New Password</label>
            <input
              className="px-3 py-3 outline-none border border-gray-300 w-full"
              type="password"
              placeholder="Enter new password"
            />
          </div>
          <div className="w-full md:w-[350px]">
            <label className="block mb-1">Retype New Password</label>
            <input
              className="px-3 py-3 outline-none border border-gray-300 w-full"
              type="password"
              placeholder=""
            />
          </div>
        </div>

        <div className="mt-5">
          <button className="px-5 py-3 bg-primary text-white font-bold ">
            Change Password
          </button>
        </div>
      </div>
     </div>
    </div>
  );
};

export default Profile;
